// A summary of outstanding refunds
import React from "react";
import WhiteBox from "../../Styled/WhiteBox";

export default function OutstandingRefunds() {
  return <WhiteBox>Outstanding Refunds</WhiteBox>;
}
